import { render, staticRenderFns } from "./LinkPacientePerfilComponente.vue?vue&type=template&id=f58e05c0"
import script from "./LinkPacientePerfilComponente.vue?vue&type=script&lang=js"
export * from "./LinkPacientePerfilComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports